<template>
  <div class="center">
    <div class="blue-title">请读取身份证信息</div>
    <img src="../../../../../../assets/common/fake-card.png" alt="">
    <el-button v-if="socket" :loading="loading">{{ readText }}</el-button>
    <el-button v-else>将身份证放置到读卡器上后等待自动读取</el-button>
  </div>
</template>

<script>
import IdCardReader from '../../../../../../mixins/custom/id-card-reader'
import {mapState} from 'vuex'
export default {
  name: 'readCard',
  mixins: [IdCardReader],
  data () {
    return {
      readText: '读卡中，请放身份证',
      loading: true
    }
  },
  computed: mapState({
    idCardConfigure: state => state.configure.idCard
  }),
  methods: {
    onReceiveCard (idCard) {
      this.$emit('get-user-data', idCard)
    },
    bindReceiveCard () {
      this.$on('receive-card', this.onReceiveCard)
    },
    unbindReceiveCard () {
      this.$off('receive-card', this.onReceiveCard)
    }
  },
  mounted () {
    this.bindReceiveCard()
  },
  beforeDestroy () {
    this.unbindReceiveCard()
  }
}
</script>

<style scoped lang="scss">
.blue-title {
  color: #0D59A7;
  position: relative;
  font-weight: 550;
  padding-left: 10px;
  font-size: 13px;

  &::before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 20px;
    background-color: #02A7F0;
    margin-right: 10px;
    position: absolute;
    left: 2px;
  }
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 50px;
  background-color: #fff;

  & > .blue-title {
    width: 500px;
    text-align: left;
    margin-bottom: 30px;
  }

  & > img {
    width: 500px;
    object-fit: contain;
  }

  .el-button {
    margin-top: 15px;
    width: 300px;
    font-size: 16px;
  }
}
</style>
